// extracted by mini-css-extract-plugin
export var md = "_5t-4";
export var sm = "_5t-3";
export var text = "_5t-5";
export var toggleInput = "_5t-0";
export var toggleSwitch = "_5t-1";
export var xs = "_5t-2";